// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2Ry7X","colCheckbox":"styles_colCheckbox__w_juE"};